import * as angular from "angular";
import {OmsOrdersBulkEditPayload} from "../models/oms-orders-bulk-edit-payload.model";
import {IHttpService} from "angular";
import {OmsOrdersTableQueryModel} from "../models/oms-orders-table-query.model";
import {ExportOmsOrdersTablePayloadModel} from "../models/export-oms-orders-table-payload.model";
import {SplitService} from "../../commons/services/split-service.service";
import {ApiConfig} from "../../commons/models/api-config.model";
import {CancellationReason} from "../../cancellation-reasons/models/cancellationReason.model";
import {AddressQualityEnum} from "../../addresses/types/address-quality.enum";
import {SchedulingSmsStatusEnum} from "../types/scheduling-sms-status.enum";
import {OmsOrdersUpdateMetadataRequestModel} from "../models/oms-orders-update-metadata-request.model";
import {SuperSearchSortMethodType} from "../../search/types/super-search-sort-method.type";
import {OmsOrderFilterModel} from "../models/oms-order-filter.model";
import {OmsOrdersQuantitiesModel} from "../models/oms-orders-quantities.model";

export class OmsRequestsService {

  /* @ngInject */
  constructor(private OmsOrderAPI, private $omsOrder, private apiConfig: ApiConfig, private $settings,
              private splitService: SplitService, private Upload,
              private SettingsAPI, private $http: IHttpService) {
  }

  getOrdersTotals(from, to, branchIds, accountIds, serviceAreaIds, tagNames, isNotTag, attempts, isPacked,
                  schedulingRequired, obligateTimeWindow, partiallyScheduled, filterByCreatedAt, displayStatus,
                  noFromLocation, noToLocation, programTypes: string[], configuredFieldName: string, configuredFieldValue: string, addressQualityGroup: AddressQualityEnum[], schedulingSmsStatuses?: SchedulingSmsStatusEnum[],
                  pickupDepotIds?: string[], destinationDepotIds?: string[], searchTerm?: string, depotIds?: string[], noArea?: boolean) {
    const api = this.OmsOrderAPI.actions.totals;

    return this.$$call(
      api,
      {
        from: from,
        to: to,
        branchIds: branchIds,
        accountIds: accountIds,
        serviceAreaIds: serviceAreaIds,
        noArea: noArea,
        tags: tagNames,
        noTags: isNotTag,
        filterByCreatedAt: filterByCreatedAt,
        attempts: attempts,
        packed: isPacked,
        schedulingRequired: schedulingRequired,
        obligateTimeWindow: obligateTimeWindow,
        partiallyScheduled: partiallyScheduled,
        displayStatus: displayStatus,
        noFromLocation: noFromLocation,
        noToLocation: noToLocation,
        programType: programTypes,
        configuredFieldId: configuredFieldName,
        configuredFieldValue: configuredFieldValue,
        addressQualityGroup: addressQualityGroup,
        deliverySchedulingStatus: schedulingSmsStatuses,
        pickupDepotIds: pickupDepotIds,
        destinationDepotIds: destinationDepotIds,
        searchTerm: searchTerm,
        depotIds: depotIds
      },
      {},
      {});
  }

  getOrdersQuantities(filter: OmsOrderFilterModel): Promise<OmsOrdersQuantitiesModel> {
    const api = this.OmsOrderAPI.actions.quantities;
    return this.$$call(api, {}, filter, {});
  }

  bulkDispatch(dispatchTimeWindowsPerLegRequest, ids, excludedIds, status, partiallyScheduled, from, to,
               branchIds, accountIds, serviceAreaIds, tags, packed, attempts, isNoTags, schedulingRequired,
               obligateTimeWindow, searchTerm, isSendSms, filterByCreatedAt, displayStatus, noFromLocation,
               noToLocation, configuredFieldName: string, configuredFieldValue: string, addressQualityGroup: AddressQualityEnum[], schedulingSmsStatuses?: SchedulingSmsStatusEnum[],
               pickupDepotIds?: string[], destinationDepotIds?: string[], depotIds?: string[], programTypes?: string[], noArea?: boolean) {
    const api = this.OmsOrderAPI.actions.bulkDispatch;
    return this.$$call(
      api,
      {
        ids: ids,
        excludedIds: excludedIds,
        status: status,
        partiallyScheduled: partiallyScheduled,
        from: from,
        to: to,
        branchIds: branchIds,
        accountIds: accountIds,
        serviceAreaIds: serviceAreaIds,
        noArea: noArea,
        tags: tags,
        packed: packed,
        attempts: attempts,
        noTags: isNoTags,
        schedulingRequired: schedulingRequired,
        obligateTimeWindow: obligateTimeWindow,
        searchTerm: searchTerm,
        sendSms: isSendSms,
        filterByCreatedAt: filterByCreatedAt,
        displayStatus: displayStatus,
        noFromLocation: noFromLocation,
        noToLocation: noToLocation,
        configuredFieldId: configuredFieldName,
        configuredFieldValue: configuredFieldValue,
        addressQualityGroup: addressQualityGroup,
        deliverySchedulingStatus: schedulingSmsStatuses,
        pickupDepotIds: pickupDepotIds,
        destinationDepotIds: destinationDepotIds,
        depotIds: depotIds,
        programType: programTypes
      },
      dispatchTimeWindowsPerLegRequest,
      {});
  }

  getPricingOffer(order) {
    const api = this.OmsOrderAPI.actions.getPricingOffer;
    return this.$$call(api, {}, order, {});
  }

  createOrder(order, saveAsDraft?) {
    const api = this.OmsOrderAPI.actions.create;
    return this.$$call(api, {draft: saveAsDraft}, order, {});
  }

  createMultipleOrders(order, numberOfOrders: number, saveAsDraft: boolean) {
    const api = this.OmsOrderAPI.actions.createMultiple;
    return this.$$call(api, {draft: saveAsDraft, numberOfOrders: numberOfOrders}, order, {});
  }

  createMultipleWithSettings(payload, numberOfOrders: number) {
    const api = this.OmsOrderAPI.actions.createMultipleWithSettings;
    return this.$$call(api, {numberOfOrders: numberOfOrders}, payload, {});
  }

  createReturnDeliveryOrder(orderId, fulfillmentLineId, order) {
    const api = this.OmsOrderAPI.actions.createReturnDeliveryOrder;
    return this.$$call(api, {}, order, {orderId: orderId, fulfillmentLineId: fulfillmentLineId});
  }

  autoDispatch(orderId) {
    const api = this.OmsOrderAPI.actions.autoDispatch;
    return this.$$call(api, {}, {}, {orderId: orderId});
  }

  updateOrder(id, updatedOrder) {
    const api = this.OmsOrderAPI.actions.update;
    return this.$$call(api, {}, updatedOrder, {id: id});
  }

  updateCompletedOrder(orderId, updatedOrder) {
    const api = this.OmsOrderAPI.actions.updateCompletedOrder;
    return this.$$call(api, {}, updatedOrder, {orderId: orderId})
  }

  cancelOrder(id, cancellationReason?: CancellationReason) {
    const api = this.OmsOrderAPI.actions.cancel;
    return this.$$call(api, {}, cancellationReason || {}, {id: id});
  }

  setOrderOnHold(id, text) {
    const api = this.OmsOrderAPI.actions.onHold;
    return this.$$call(api, {}, {text: text}, {id: id});
  }

  resumeOrder(id, sendSms) {
    const api = this.OmsOrderAPI.actions.resume;
    return this.$$call(api, {sendSms: sendSms}, {}, {id: id});
  }

  manuallyCompleteOrder(id) {
    const api = this.OmsOrderAPI.actions.manuallyComplete;
    return this.$$call(api, {}, {}, {id: id});
  }

  cancelOrders(ids, excludedIds, statuses, partiallyScheduled, from, to, branchIds, accountIds, serviceAreaIds,
               tagNames, attempts, isPacked, schedulingRequired, obligateTimeWindow, filterByCreatedAt, displayStatus,
               noFromLocation, noToLocation, programTypes: string[], configuredFieldName: string, configuredFieldValue: string,
               addressQualityGroup: AddressQualityEnum[], schedulingSmsStatuses?: SchedulingSmsStatusEnum, cancellationReason?: CancellationReason,
               pickupDepotIds?: string[], destinationDepotIds?: string[], searchTerm?: string, depotIds?: string[], isNotTag?: boolean, noArea?: boolean) {
    const api = this.OmsOrderAPI.actions.cancelBulk;
    return this.$$call(api, {
      ids: ids,
      excludedIds: excludedIds,
      statuses: statuses,
      partiallyScheduled: partiallyScheduled,
      from: from,
      to: to,
      branchIds: branchIds,
      accountIds: accountIds,
      serviceAreaIds: serviceAreaIds,
      noArea: noArea,
      tags: tagNames,
      noTags: isNotTag,
      attempts: attempts,
      packed: isPacked,
      schedulingRequired: schedulingRequired,
      obligateTimeWindow: obligateTimeWindow,
      filterByCreatedAt: filterByCreatedAt,
      displayStatus: displayStatus,
      noFromLocation: noFromLocation,
      noToLocation: noToLocation,
      programType: programTypes,
      configuredFieldId: configuredFieldName,
      configuredFieldValue: configuredFieldValue,
      addressQualityGroup: addressQualityGroup,
      deliverySchedulingStatus: schedulingSmsStatuses,
      pickupDepotIds: pickupDepotIds,
      destinationDepotIds: destinationDepotIds,
      searchTerm: searchTerm,
      depotIds: depotIds
    }, cancellationReason || {}, {});
  }

  uploadOrdersExcel(file, accountId, customSchemaId?) {
    const siteId = this.splitService.getSiteId();
    return new Promise((resolve, reject) => {
      this.Upload.upload({
        url: this.apiConfig.baseUrl + `/importers-oms/upload`,
        method: 'POST',
        params: {
          siteId: siteId,
          defaultAccountId: accountId,
          zoneId: this.splitService.getTimeZone(),
          customSchemaId
        },
        data: {
          file: file
        }
      })
        .then((response) => {
          resolve(response.data);
        })
        .catch((response) => {
          reject(response.data);
        });
    });
  }

  scheduleSelfPickup(id, selfPickup) {
    const api = this.OmsOrderAPI.actions.scheduleSelfPickup;
    return this.$$call(api, {}, selfPickup, {id: id});
  }

  scheduleDeliveries(orderIds?, programType?, notBefore?, notAfter?, excludedIds?, from?, to?, statuses?, branchIds?,
                     accountIds?, serviceAreaIds?, tags?, noTagsEnabled?, attempts?, isPacked?,
                     schedulingRequired?, obligateTimeWindow?, configuredFieldName?: string, configuredFieldValue?: string) {
    const api = this.OmsOrderAPI.actions.scheduleDeliveries;
    const params = {
      ids: orderIds,
      programType: programType,
      from: from,
      to: to,
      notBefore: notBefore,
      notAfter: notAfter,
      excludedIds: excludedIds,
      statuses: statuses,
      branchIds: branchIds,
      accountIds: accountIds,
      serviceAreaIds: serviceAreaIds,
      tags: tags,
      noTags: noTagsEnabled,
      attempts: attempts,
      packed: isPacked,
      schedulingRequired: schedulingRequired,
      obligateTimeWindow: obligateTimeWindow,
      configuredFieldName: configuredFieldName,
      configuredFieldValue: configuredFieldValue,
    };
    return this.$$call(api, params, {}, {});
  }

  get3plsSettings() {
    const api = this.SettingsAPI.actions.getOms3plsSettings;
    return this.$$callSettings(api, {}, {}, {});
  }

  update3plsSettings(settings) {
    const api = this.SettingsAPI.actions.updateOms3plsSettings;
    return this.$$callSettings(api, {}, settings, {});
  }

  getPDFBolByOrderId(orderId) {

    const base_url = this.apiConfig.baseUrl + `/oms/orders-v2/`;
    return this.$http.get(base_url + `${orderId}/billoflading`, {
      params: {
        siteId: this.splitService.getSiteId(),
      },
      responseType: "arraybuffer"
    })

  }

  sendSchedulingLink(orderId, ignoreOrderStatus?) {
    const api = this.OmsOrderAPI.actions.sendSchedulingLink;
    return this.$$call(api, {ignoreOrderStatus: ignoreOrderStatus}, {}, {orderId: orderId});
  }

  sendSchedulingLinkWhatsapp(orderId, ignoreOrderStatus?) {
    const api = this.OmsOrderAPI.actions.sendSchedulingLinkWhatsapp;
    return this.$$call(api, {ignoreOrderStatus: ignoreOrderStatus}, {}, {orderId: orderId});
  }

  bulkSendSchedulingLink(data, ignoreOrderStatus?: boolean, branchIds?: string[]) {
    const api = this.OmsOrderAPI.actions.bulkSendSchedulingLink;
    return this.$$call(api, {ignoreOrderStatus, branchIds}, data, {});
  }

  bulkSendSchedulingLinkWhatsapp(data, ignoreOrderStatus?: boolean, branchIds?: string[]) {
    const api = this.OmsOrderAPI.actions.bulkSendSchedulingLinkWhatsapp;
    return this.$$call(api, {ignoreOrderStatus, branchIds}, data, {});
  }

  getSchedulingForm(orderId: string) {
    const api = this.OmsOrderAPI.actions.getSchedulingForm;
    return this.$$call(api, {}, {}, {orderId: orderId});
  }

  get3plsAssignOptions(orderId) {
    const api = this.OmsOrderAPI.actions.get3plsAssignOptions;
    return this.$$call(api, {}, {}, {orderId: orderId});
  }

  assignToSupplier(orderId, supplier) {
    const api = this.OmsOrderAPI.actions.assignToSupplier;
    return this.$$call(api, {}, supplier, {orderId: orderId});
  }

  addNote(orderId, note) {
    const api = this.OmsOrderAPI.actions.addNote;
    return this.$$call(api, {}, note, {orderId: orderId});
  }

  getOrderInfo(orderId) {
    const api = this.OmsOrderAPI.actions.getOrderInfo;
    return this.$$call(api, {}, {}, {orderId: orderId});
  }

  validateServiceAreas(order) {
    const api = this.OmsOrderAPI.actions.validateServiceAreas;
    return this.$$call(api, {}, order, {});
  }

  getOrderTaskTimeSlots(accountId, depotId, lineType, from, to, programType, zoneId) {
    const api = this.OmsOrderAPI.actions.getOrderTaskTimeSlots;
    return this.$$call(api, {
      accountId: accountId,
      depotId: depotId,
      lineType: lineType,
      from: from,
      to: to,
      programType: programType,
      zoneId: zoneId
    }, {}, {});
  }

  getLogsTimeline(orderId) {
    var api = this.OmsOrderAPI.actions.getLogsTimeline;
    return this.$$call(api, {}, {}, {orderId: orderId});
  }

  recoverOrder(orderId) {
    var api = this.OmsOrderAPI.actions.recoverOrder;
    return this.$$call(api, {}, {}, {orderId: orderId});
  }

  getGlobalSearch(query: string, limit: number = 10, autoComplete: boolean = true, sortMethod?: SuperSearchSortMethodType) {
    const siteId = this.splitService.getSiteId();
    const api = this.OmsOrderAPI.actions.globalSearch;
    return this.$$call(api, {
      query: query,
      siteId: siteId,
      limit: limit,
      autoComplete: autoComplete,
      sortMethod: sortMethod
    }, {}, {});
  }

  emailBOL(emailRecipients: string[], note: string, orderId) {
    var api = this.OmsOrderAPI.actions.emailBOL;
    return this.$$call(api, {}, {emailRecipients: emailRecipients, note: note}, {id: orderId});
  }

  bulkUpdate(omsOrdersBulkEditPayload: OmsOrdersBulkEditPayload) {
    const api = this.OmsOrderAPI.actions.bulkUpdate;
    return this.$$call(api, {}, omsOrdersBulkEditPayload, {});
  }

  cancelFulfillmentLines(orderId: string, lineIds: string[]) {
    var api = this.OmsOrderAPI.actions.cancelFulfillmentLines;
    return this.$$call(api, {ids: lineIds}, {}, {id: orderId});
  }

  deleteNote(orderId: string, noteId: string) {
    const api = this.OmsOrderAPI.actions.deleteNote;
    return this.$$call(api, {noteId: noteId}, {}, {orderId: orderId});
  }

  exportOrdersTable(queryParams: OmsOrdersTableQueryModel, payload: ExportOmsOrdersTablePayloadModel) {
    const api = this.OmsOrderAPI.actions.export;
    return this.$$call(api, queryParams, payload, {});
  }

  updateOrderMetaData(orderId: string, metaData: {key: string, value: string}[]) {
    const api = this.OmsOrderAPI.actions.updateOrderMetaData;
    return this.$$call(api, {}, metaData, {orderId: orderId});
  }

  updateOrdersMetaData(payload: OmsOrdersUpdateMetadataRequestModel) {
    const api = this.OmsOrderAPI.actions.updateOrdersMetaData;
    return this.$$call(api, {}, payload, {});
  }

  private $$call(_apiCall, _params, _data, _options, id?) {
    return this.$omsOrder(id).$call(_apiCall, _params, _data, _options);
  }

  private $$callSettings(_apiCall, _params, _data, _options) {
    return this.$settings().$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.oms')
  .service('omsRequestsService', OmsRequestsService);
